// extracted by css-extract-rspack-plugin
export default {"selected-items-extras":"UDHgwh","selectedItemsExtras":"UDHgwh"};